import { combineEpics } from 'redux-observable';
import SearchEpics from './SearchEpics';
import AnalyticsEpics from './AnalyticsEpics';

export default combineEpics(
  AnalyticsEpics as any, // see https://github.com/redux-observable/redux-observable/issues/219
  SearchEpics,
);
